import React from "react";

const InfoIcon = (props: React.ComponentProps<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M3.3335 3.33423H16.6668V15.0009C16.6668 15.9214 15.9206 16.6676 15.0002 16.6676H5.00016C4.07969 16.6676 3.3335 15.9214 3.3335 15.0009V3.33423Z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="10"
      y="6.66675"
      width="0.00875"
      height="0.00875"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M10 10V13.3333"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default InfoIcon;
